import { IVehicle } from '@interfaces/IVehicle';
import { CacheService } from '@services/cache.Service';
import { IVehiclePeripheralMapping } from '@interfaces/IVehiclePeripheralMapping';

export class FoundationVehicleService {

    foundationVehiclesCache = "foundationVehiclesCache";
    foundationActiveVehiclesCache = "foundationActiveVehiclesCache";

    static $inject = ["$http", "cacheService"];

    constructor(
        private readonly $http: angular.IHttpService,
        private readonly cacheService: CacheService) {

        this.cacheService.createCache(this.foundationVehiclesCache, { maxAge: 5 * 60 * 1000 });
        this.cacheService.createCache(this.foundationActiveVehiclesCache, { maxAge: 5 * 60 * 1000 });
    }

    createUpdateVehicle(vehicle: IVehicle): angular.IPromise<IVehicle> {
        return this.$http({
            url: `/api/foundation/vehicles/`,
            data: vehicle,
            method: "POST"
        }).then((response: angular.IHttpPromiseCallbackArg<IVehicle>) => {
            return response.data;
        });
    }

    updateVehicleData(vehicle: IVehicle): angular.IPromise<void> {
        return this.$http<void>({
            url: `/api/foundation/vehicles/updatevehicledata`,
            data: vehicle,
            method: "POST"
        }).then((result: angular.IHttpResponse<void>) => {
            return result.data;
        });
    }

    createVehicle(): angular.IPromise<IVehicle[]> {
        return this.$http<IVehicle[]>({
            url: `/api/foundation/vehicles/`,
            method: "GET",
            cache: false
        }).then(response => {
            return response.data;
        });
    }

    getVehicle(vehicleId: number, invalidateCache = false): angular.IPromise<IVehicle> {
        return this.$http<IVehicle>({
            url: `/api/foundation/vehicles/${vehicleId}`,
            method: "GET",
            cache: false
        }).then(response => {
            return response.data;
        });
    }

    getVehicles(invalidateCache = false): angular.IPromise<IVehicle[]> {
        return this.cacheService.getOrRetrieveData(this.foundationVehiclesCache, () => this.getVehiclesFromDatabase(), invalidateCache);
    }

    getActiveVehicles(invalidateCache = false): angular.IPromise<IVehicle[]> {
        return this.cacheService.getOrRetrieveData(this.foundationActiveVehiclesCache, () => this.getVehiclesFromDatabase(true), invalidateCache);
    }

    getVehiclesExtended(): angular.IPromise<IVehicle[]> {
        return this.$http<IVehicle[]>({
            url: `/api/foundation/vehicles/extendedinfo/`,
            method: "GET",
            cache: false
        }).then(response => {
            return response.data;
        });
    }

    getPeripheralMapping(serial: string): angular.IPromise<IVehiclePeripheralMapping> {
        return this.$http<IVehiclePeripheralMapping>({
            url: `/api/foundation/vehicles/peripheral/${serial}`,
            method: "GET",
            cache: false
        }).then(response => {
            return response.data;
        });
    }

    getVehicleUnitLocation(vehicleId: number): angular.IPromise<string> {
        return this.$http<string>({
            url: `/api/foundation/vehicles/${vehicleId}/unitlocation`,
            method: "GET",
            cache: false
        }).then(response => {
            return response.data;
        })
    }

    createVehicleMap(vehicles: IVehicle[]): Map<number, IVehicle> {
        return new Map(vehicles.map(a => [a.Id, a]));
    }

    // ---

    private getVehiclesFromDatabase(activeVehiclesOnly: boolean = false) {
        return this.$http<IVehicle[]>({
            url: `/api/foundation/vehicles/`,
            method: "GET",
            cache: false,
            params: { activeVehiclesOnly }
        }).then(response => {

            response.data.forEach(v => {


            });
            return response.data;
        });
    }
}
